__turbopack_context__.v({
  "colorScheme--light": "fnFXdG_colorScheme--light",
  "container": "fnFXdG_container",
  "isSale": "fnFXdG_isSale",
  "size--lg": "fnFXdG_size--lg",
});
